import LoadingButton from "@mui/lab/LoadingButton"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import FormControlLabel from "@mui/material/FormControlLabel"
import Radio from "@mui/material/Radio"
import RadioGroup from "@mui/material/RadioGroup"
import Typography from "@mui/material/Typography"
import { useEffect, useState } from "react"

import { useAuthorizedAxiosClient } from "../../../common/axios"
import Column from "../../../common/components/Column"
import ConditionalPurpleLinearProgress from "../../../common/components/ConditionalLinearProgress"
import DialogHeader from "../components/DialogHeader"

const DELETE_SCOPE = {
  selected: "selected",
  all: "all",
}

export default function ConfirmDeleteUploadedLeadsDialog({
  open,
  onClose,
  selectedCount,
  totalCount,
  selectedLeadIds,
  filters,
}) {
  const [deleteScope, setDeleteScope] = useState(DELETE_SCOPE.selected)
  const [isDeleting, setIsDeleting] = useState(false)
  const axios = useAuthorizedAxiosClient()
  const showAllOption = totalCount > selectedCount
  const deleteCount =
    deleteScope === DELETE_SCOPE.all ? totalCount : selectedCount

  useEffect(() => {
    if (open) {
      setDeleteScope(DELETE_SCOPE.selected)
    }
  }, [open])

  function handleSoftClose() {
    onClose()
  }

  function handleDeleteButtonClicked() {
    setIsDeleting(true)
    const payload =
      deleteScope === DELETE_SCOPE.all
        ? { delete_all: true, filters }
        : { uploaded_lead_ids: selectedLeadIds }

    axios
      .delete("/crm/api/uploaded-leads/bulk/delete/", { data: payload })
      .then(({ data }) => {
        onClose(true, data.deleted_count, deleteScope)
      })
      .catch(() => onClose("error"))
      .finally(() => setIsDeleting(false))
  }

  return (
    <Dialog open={open} onClose={handleSoftClose} maxWidth="xs" fullWidth>
      <DialogHeader title="Delete import leads?" onClose={handleSoftClose} />
      <ConditionalPurpleLinearProgress visible={isDeleting} />
      <DialogContent>
        <Column sx={{ gap: 2 }}>
          <Typography variant="body1" color="text.secondary">
            This permanently removes import leads from your CRM. This action
            cannot be undone.
          </Typography>
          {showAllOption ? (
            <RadioGroup
              value={deleteScope}
              onChange={(e) => setDeleteScope(e.target.value)}
            >
              <FormControlLabel
                value={DELETE_SCOPE.selected}
                control={<Radio color="primary" />}
                label={`Delete ${selectedCount.toLocaleString()} selected lead${
                  selectedCount === 1 ? "" : "s"
                }`}
              />
              <FormControlLabel
                value={DELETE_SCOPE.all}
                control={<Radio color="primary" />}
                label={`Delete all ${totalCount.toLocaleString()} import leads`}
              />
            </RadioGroup>
          ) : (
            <Typography variant="body1">
              Delete <strong>{selectedCount.toLocaleString()}</strong> import
              lead
              {selectedCount === 1 ? "" : "s"}?
            </Typography>
          )}
        </Column>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={handleSoftClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          color="error"
          loading={isDeleting}
          onClick={handleDeleteButtonClicked}
        >
          Delete {deleteCount.toLocaleString()}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
